<script>
import { Line } from 'vue-chartjs'

export default {   
    name: 'line-graph',
    extends: Line,

    props: {
		name: {
			type: String,
			default: 'Line Graph'
		},
        data: {
            type: Array
        },
        max: {
            type: Number
        }
    },


	mounted() {
		this.renderChart({
            labels:  this.getLabels, // Y axis
            datasets: [
                {
                    label: this.name,
                    backgroundColor: 'skyblue',
                    borderColor: 'skyblue',
                    data: this.getData,
                    fill: false
                }
            ]
        }, { responsive: true, maintainAspectRatio: false, 
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            // stepSize: 1,
                            max: this.max,
                            min: 0
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                }
            }
        )
	},
    
    computed: {
        getLabels() {
            return this.data.map(d => d.date)
        },
        getData() {
            return this.data.map(d => parseInt(d.value))
        }
    },
    
    components: {}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
